import React, { RefObject } from 'react';

import { PAGES } from '@services/routingService';
import { EPage, ReactFCV } from '@types';

import { IPayPalOrderState } from '../reducer';

interface IPayPalExpressForm extends IPayPalOrderState {
  formRef: RefObject<HTMLFormElement>;
  baseUrl: string;
}

export const PayPalExpressForm: ReactFCV<IPayPalExpressForm> = ({
  baseUrl,
  formRef,
  facilitatorAccessToken,
  billingToken,
  payerId,
  orderId,
  customer,
  deliveryAddress,
}) => (
  <form id="paypal-express-form" action={`${baseUrl}${PAGES[EPage.SUMMARY]?.external}`} method="post" ref={formRef}>
    <input type="hidden" id="react-validate-form" name="ReactValidateForm" value="1" />
    <input type="hidden" id="form-id" name="FormId" value="paypalExpressCheckout" />
    <input type="hidden" id="billing-token" name="BillingToken" value={billingToken} />
    <input type="hidden" id="facilitator-access-token" name="FacilitatorAccessToken" value={facilitatorAccessToken} />
    <input type="hidden" id="order-id" name="OrderId" value={orderId} />
    <input type="hidden" id="payer-id" name="PayerId" value={payerId} />
    <input type="hidden" id="first-name" name="FirstName" value={customer?.firstName} />
    <input type="hidden" id="last-name" name="LastName" value={customer?.lastName} />
    <input type="hidden" id="phone" name="Phone" value={customer?.phone ?? ''} />
    <input type="hidden" id="email" name="Email" value={customer?.email ?? ''} />
    <input type="hidden" id="street-name" name="StreetName" value={deliveryAddress?.streetName} />
    <input
      type="hidden"
      id="house-number-or-name"
      name="HouseNumberOrName"
      value={deliveryAddress?.houseNumberOrName ?? ''}
    />
    <input type="hidden" id="city" name="City" value={deliveryAddress?.city} />
    <input type="hidden" id="zip-code" name="ZipCode" value={deliveryAddress?.zipCode} />
    <input type="hidden" id="state-province" name="StateProvince" value={deliveryAddress?.stateProvince ?? ''} />
  </form>
);
